import React, {Component} from 'react';

import {DragDropContext} from 'react-beautiful-dnd';

import PortalAdminAccessTree from './PortalAdminAccessTree';
import PortalAdminItems from './PortalAdminItems';
import Button from 'ROOT/src/components/formElements/Button';

import sAction from 'sAction';

class PortalAdminContainer extends React.Component {
    constructor(props) {
        super(props);

        const usersPre = props.data.get('users');
        const rolesPre = props.data.get('roles');
        const rolesPom = props.data.get('rolesPom');

        const parent = props.data.get('parent');
        const branchesPre = props.data.get('accounts');

        const users = {};
        const roles = {};

        const parentId = parent.get('id');

        const branches = {};

        branches[parentId] = {
            id: parentId,
            name: parent.get('name'),
            type: 'root',
            roles: {},
        };

        branchesPre.forEach((br) => {
            const id = br.get('id');
            branches[id] = {
                id: id,
                name: br.get('name'),
                roles: {},
            };
        });

        let ind = 0;

        usersPre.forEach((user) => {
            const id = user.get('id');
            users[id] = {
                id: id,
                name: user.get('name'),
                branch: user.get('branch'),
                index: ind++,
            };
        });

        ind = 0;

        rolesPre.forEach((role) => {
            const id = role.get('id');
            roles[id] = {
                id: id,
                name: role.get('name'),
                index: ind++,
                usersCnt: 0,
            };
        });

        rolesPom.entrySeq().forEach((acc) => {
            if (branches[acc[0]]) {
                acc[1].get('roles').entrySeq().forEach((role) => {
                    if (roles[role[0]]) {
                        this.addRole(acc[0], {...roles[role[0]]}, branches);
                        role[1].get('users').forEach( (user) => {
                            if (users[user]) {
                                this.addUser(acc[0], role[0], {...users[user]}, branches);
                                roles[role[0]].usersCnt++;
                            }
                        });
                    }
                });
            }
        });

        this.state = {
            roles: roles,
            users: users,
            branches: branches,
            ignoredUsers: [],
        };
    }

    setModified(val) {
        sAction.dataSet(this.props.way+'/needSave', val);
    }


    handleSave() {
        const params = {
            'branches': this.state.branches,
        };

        sAction.load();

        sAction.rest.post('setAdminData', params, (data) => {
            sAction.dataSet('view/needSave', false);
            sAction.unLoad();
        });
    }

    addRole(acc, role, branches) {
        role.users = {};
        role.dropId = acc+'|'+role.id;
        branches[acc].roles[role.id] = role;
    }

    addUser(acc, role, user, branches) {
        branches[acc].roles[role].users[user.id] = user;
    }


    onDragEnd(result) {
        const branches = this.state.branches;
        const roles = this.state.roles;
        if (result.type === 'ROLES' &&
        result.destination !== null) {
            const role = {...this.state.roles[result.draggableId]};
            const bId = result.destination.droppableId;
            if (!branches[bId] || !role) {
                return;
            }

            if (branches[bId]['roles'][role.id]) {
                return;
            }

            this.addRole(bId, role, branches);
        } else if (result.type === 'USERS' &&
        result.destination !== null) {
            const pom = result.destination.droppableId.split('|');
            if (pom.length != 2) {
                return;
            }

            const bId = pom[0];
            const rId = pom[1];

            const user = {...this.state.users[result.draggableId]};
            if (!branches[bId].roles[rId].users[user.id]) {
                this.addUser(bId, rId, user, branches);
                roles[rId].usersCnt++;
            }
        } else {
            return;
        }

        this.setState({
            branches: branches,
            roles: roles,
        });
        this.setModified(true);
    }

    massAssignCallback(params, users) {
        const branches = this.state.branches;
        const roles = this.state.roles;

        params.roles.forEach((rId) => {
            const role = roles[rId];
            params.branches.forEach((bId) => {
                if (!branches[bId]['roles'][rId]) {
                    this.addRole(bId, role, branches);
                }

                users.forEach((uId) => {
                    const user = this.state.users[uId];

                    if (!branches[bId].roles[rId].users[user.id]) {
                        this.addUser(bId, rId, user, branches);
                        roles[rId].usersCnt++;
                    }
                });
            });
        });
        this.setState({
            branches: branches,
            roles: roles,
        });
        this.setModified(true);
    }

    massAssigneUsers(users) {
        const roles = [];
        const branches = [];
        this.state.roles.forEachObject((it, key) => {
            roles.push({
                id: it.id,
                name: it.name,
            });
        });
        this.state.branches.forEachObject((it, key) => {
            branches.push({
                id: it.id,
                name: it.name,
            });
        });

        sAction.popup('PortalAdminMassAssignUsers', {
            header: sAction.translate('LBL_MASS_ASSIGN_ROLE_ACCOUNT', 'acm_portal_users'),
            data: {
                roles,
                branches,
                callback: (params) => this.massAssignCallback(params, users),
            },

        });
    }


    render() {
        const deleteUser = (params) => {
            const branches = this.state.branches;
            const roles = this.state.roles;
            delete branches[params.bId]['roles'][params.rId]['users'][params.uId];
            roles[params.rId].usersCnt--;
            this.setState({
                branches: branches,
            });
            this.setModified(true);
        };

        const deleteRole = (params) => {
            sAction.confrim(sAction.translate('LBL_DELETE_ROLE_CONFIRM_ROLE', 'acm_portal_roles'), () => {
                const branches = this.state.branches;
                const roles = this.state.roles;
                roles[params.rId].usersCnt -= Object.keys(branches[params.bId]['roles'][params.rId].users).length;
                delete branches[params.bId]['roles'][params.rId];
                this.setState({
                    branches: branches,
                    roles: roles,
                });
                sAction.popupHide();
                this.setModified(true);
            });
            /*

            */
        };


        const searchAccount = (val) => {
            this.state.branches.forEachObject((acc) => {
                if (!acc.name.toLowerCase().includes(val.toLowerCase())) {
                    document.getElementById('company'+acc.id).style.display='none';
                } else {
                    document.getElementById('company'+acc.id).style.display='block';
                }
            });
        };

        const searchRole = (val) => {
            this.state.roles.forEachObject((role) => {
                if (!role.name.toLowerCase().includes(val.toLowerCase())) {
                    document.getElementById('roles'+role.id).style.display='none';
                } else {
                    document.getElementById('roles'+role.id).style.display='block';
                }
            });
        };

        const searchUser = (val) => {
            const ignoredUsers = [];
            this.state.users.forEachObject((role) => {
                if (!role.name.toLowerCase().includes(val.toLowerCase())) {
                    document.getElementById('users'+role.id).style.display='none';
                    ignoredUsers.push(role.id);
                } else {
                    document.getElementById('users'+role.id).style.display='block';
                }
            });
            this.setState({ignoredUsers: ignoredUsers});
        };

        return <div className="detailCard">
            <div className="header">
                <div className="title">
                    <span className="detailViewName">
                        {sAction.translate('LBL_ADMIN_ACESS_TITLE', 'acm_portal_roles')}
                    </span>
                </div>
            </div>
            <div className="divider" />
            <div className="viewActionPanel portalAdminButtons">
                <Button
                    className="roundedDetailAction greenBtn"
                    onClick={() => this.handleSave()}>
                    <div className="actionPanelButtonIcon icon-saveIcon"/>
                    {sAction.translate('LBL_SAVE', 'Home')}
                </Button>
                <Button
                    className="roundedDetailAction blueBtn"
                    onClick={() => window.open('#detail/acm_portal_roles', '_blank')}>
                    <div className="actionPanelButtonIcon icon-acm_portal_roles"/>
                    {sAction.translate('LBL_CREATE_ROLE', 'acm_portal_roles')}
                </Button>
                <Button
                    className="roundedDetailAction blueBtn"
                    onClick={() => window.open('#detail/acm_portal_users', '_blank')}>
                    <div className="actionPanelButtonIcon icon-acm_portal_users"/>
                    {sAction.translate('LBL_CREATE_USER', 'acm_portal_users')}
                </Button>
            </div>
            <div className="portalAdminContainer">
                <DragDropContext
                    onDragEnd = { (res) => {
                        this.onDragEnd(res);
                    }}
                >
                    <PortalAdminItems
                        dropId="users"
                        type="USERS"
                        items={this.state.users}
                        ignoredUsers={this.state.ignoredUsers}
                        massAssigneUsers={(users) => this.massAssigneUsers(users)}
                        search={searchUser}
                    />
                    <PortalAdminItems
                        dropId="roles"
                        type="ROLES"
                        items={this.state.roles}
                        customClass="roleColumn"
                        search={searchRole}
                    />
                    <PortalAdminAccessTree
                        branches={this.state.branches}
                        deleteUser={deleteUser}
                        deleteRole={deleteRole}
                        search={searchAccount}
                    />
                </DragDropContext>
            </div>
        </div>;
    }
}
export default PortalAdminContainer;
